<template>
  <a-card :bordered="false">
    <a-row style="padding: 0 24px">
      <a-col :span="12">
        <a-radio-group v-model="listType">
          <a-radio-button :value="1">合同列表</a-radio-button>
          <a-radio-button :value="2">订单申请</a-radio-button>
          <a-radio-button :value="3">对接配置</a-radio-button>
        </a-radio-group>
      </a-col>
      <a-col :offset="12" v-if="listType === 3">
        <div class='right-setting'>
          <span style='margin-right: 15px'>对接全国旅游服务监督平台</span>
          <a @click="onPlatformSettingEvent">设置</a>
        </div>
      </a-col>
    </a-row>
    <ElectronicContractList v-if="listType === 1"/>
    <ElectronicContractOrder v-else-if="listType === 2"/>
    <ElectronicContractConfigure v-else-if="listType === 3"/>
    <a-modal
      title="对接设置"
      :width="600"
      :visible="modalVisible"
      @cancel="cancelEvent"
      :confirmLoading="submitLoading"
      @ok="submitEvent"
    >
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="AppId" prop="appId">
          <a-input v-model="ruleForm.appId" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="signKey" prop="signKey">
          <a-input v-model="ruleForm.signKey" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="环境地址" prop="requestDomain">
          <a-input v-model="ruleForm.requestDomain" :maxLength="50" placeholder="请输入http://和https://"/>
        </a-form-model-item>
        <a-form-model-item label="旅行社名称" prop="travelAgencyName">
          <a-input v-model="ruleForm.travelAgencyName" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="营业地址" prop="travelAgencyAddress">
          <a-input v-model="ruleForm.travelAgencyAddress" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="旅行社许可证号" prop="travelAgencyLicenseNumber">
          <a-input v-model="ruleForm.travelAgencyLicenseNumber" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="社会信用代码" prop="socialCreditCode">
          <a-input v-model="ruleForm.socialCreditCode" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="争议解决城市" prop="disputeResolutionCity">
          <a-input v-model="ruleForm.disputeResolutionCity" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="签约地址" prop="signAddress">
          <a-input v-model="ruleForm.signAddress" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="版本号" prop="codeVersion">
          <a-input v-model="ruleForm.codeVersion" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import ElectronicContractList from './components/ElectronicContractList'
import ElectronicContractOrder from './components/ElectronicContractOrder'
import ElectronicContractConfigure from './components/ElectronicContractConfigure'
import Vue from 'vue'

export default {
  name: 'ElectronicContractManager',
  components: {
    ElectronicContractList,
    ElectronicContractOrder,
    ElectronicContractConfigure
  },
  data() {
    return {
      listType: '', // 1合同列表 2订单申请 3对接配置
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      modalVisible: false,
      submitLoading: false,
      ruleForm: {},
      rules: {
        appId: [{ required: true, message: '请输入AppId', trigger: 'blur' }],
        signKey: [{ required: true, message: '请输入signKey', trigger: 'blur' }],
        requestDomain: [
          { required: true, message: '请输入环境地址', trigger: 'blur' },
          { pattern: /^(https?:\/\/)/, message: '请输入http://和https://开头的环境地址', trigger: 'blur' }
        ],
        travelAgencyName: [{ required: true, message: '请输入旅行社名称', trigger: 'blur' }],
        travelAgencyAddress: [{ required: true, message: '请输入营业地址', trigger: 'blur' }],
        travelAgencyLicenseNumber: [{ required: true, message: '请输入旅行社许可证号', trigger: 'blur' }],
        socialCreditCode: [{ required: true, message: '请输入社会信用代码', trigger: 'blur' }],
        disputeResolutionCity: [{ required: true, message: '请输入争议解决城市', trigger: 'blur' }],
        signAddress: [{ required: true, message: '请输入签约地址', trigger: 'blur' }],
        codeVersion: [{ required: true, message: '请输入版本号', trigger: 'blur' }]
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 17 }
    }
  },
  created() {
    if (Vue.ls.get('list_type')) {
      this.$set(this, 'listType', Vue.ls.get('list_type'))
      Vue.ls.remove('list_type')
    } else {
      this.listType = 1
    }
  },
  methods: {
    async onPlatformSettingEvent() {
      this.ruleForm = await this.getConfigDetail()
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    getConfigDetail() {
      return new Promise(resolve => {
        this.getHttpServices().getServerApiService().post('tourist/contract/configDetail', this.queryParams).then(res => {
          resolve(res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    cancelEvent() {
      this.modalVisible = false
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getServerApiService().post('tourist/contract/saveConfig', {
          ...this.ruleForm,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }).then(res => {
          this.$message.success('保存成功')
          this.cancelEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.right-setting {
  height: 32px;
  line-height: 32px;
  text-align: right;
}
</style>

